import { render } from "./PreviewTemplate.vue?vue&type=template&id=5c52575c&scoped=true"
import script from "./PreviewTemplate.vue?vue&type=script&lang=js"
export * from "./PreviewTemplate.vue?vue&type=script&lang=js"

import "./PreviewTemplate.vue?vue&type=style&index=0&id=5c52575c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c52575c"]])

export default __exports__